import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

export interface SegmentedControlOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
  activeIcon?: React.ReactNode;
  classNames?: { button?: string; buttonActive?: string };
}

interface SegmentedControlProps {
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: string) => void;
  classNames?: {
    container?: string;
    button?: string;
    buttonActive?: string;
  };
}

export const SegmentedControl = memo(function SegmentedControl({
  options,
  value,
  onChange,
  classNames,
}: SegmentedControlProps) {
  return (
    <div
      className={cn(
        "bg-segmented-control-default flex gap-2 rounded-full p-1",
        classNames?.container,
      )}
    >
      {options.map((opt) => {
        const isActive = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            className={cn(
              textVariants.bodySingleLine,
              "flex h-9 flex-1 items-center justify-center gap-2.5 rounded-full transition-all duration-200 ease-out",
              {
                "bg-segmented-control-button-active": isActive,
                [classNames?.button ?? ""]: !isActive,
                [opt.classNames?.button ?? ""]: !isActive,
                [classNames?.buttonActive ?? ""]: isActive,
                [opt.classNames?.buttonActive ?? ""]: isActive,
              },
            )}
            onClick={() => onChange(opt.value)}
          >
            {value === opt.value ? opt.activeIcon : opt.icon}
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
});

export default SegmentedControl;
